module.exports = __webpack_public_path__ + "static/media/that-was-quick.99013af2.mp3";